<template>
    <div class="moduleAppIntDetail">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
        </div>
        <div class="full-content" v-if="moduleData.name"  :style="`height: ${windowHeight-200}px;overflow: auto;`">
            <div class="application-info ">
                <div class="basic-info">
                    <img class="logo" :src="moduleData.logoUrl" />
                    <div class="application-name">
                        <h3 class="application-name__main">{{moduleData.name}}</h3>
                        <div class="application-name__desc">{{moduleData.profile}}</div>
                    </div>
                </div>
                <div class="detail-info clearfix">
                    <div class="detail-info__item">
                        <span>应用代号：</span><p>
                        {{moduleData.code}}
                        </p>
                    </div>
                    <div class="detail-info__item">
                        <span> APPID：</span><p>
                        <el-tooltip class="item" effect="dark" :content="moduleData.key" placement="top">
                            <span>{{moduleData.key}}</span>
                        </el-tooltip></p>
                    </div>
                    <div class="detail-info__item">
                        <span>验证域名：</span><p>
                        <el-tooltip class="item" effect="dark" :content="moduleData.domainName" placement="top">
                            <span>{{moduleData.domainName}}</span>
                        </el-tooltip></p>
                    </div>
                    <div class="detail-info__item">
                        <span>授信IP：</span><p>
                        <el-tooltip class="item" effect="dark" :content="moduleData.ip" placement="top">
                            <span>{{moduleData.ip}}</span>
                        </el-tooltip></p>
                    </div>
                    <div class="detail-info__item">
                        <span>敏感信息：</span><p>{{['', '发送', '不发送'][moduleData.sendSensitiveInfo]}}</p>
                    </div>
                </div>
            </div>
            <div class="application-configs clearfix">
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>PC端入口集成</h4>
                        <span data-status="0" class="app-config__status">{{['', '已开启', '未开启'][moduleData.pcUrlOnOff]}}</span>
                    </div>
                    <div class="app-config__desc">
                        在校园统一门户平台，点击该应用可以直接进入该应用的PC端。
                        <div class="url">{{moduleData.pcUrl}}</div>
                    </div>
                    <span class="app-config__setting-btn" data-config="pcEntry" @click="setConfig(1)">设置</span>
                </div>
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>数据回调配置</h4>
                        <span data-status="1" class="app-config__status">{{['', '已开启', '未开启'][moduleData.callbackUrlOnOff]}}</span>
                    </div>
                    <div class="app-config__desc">
                        将基础数据库的数据变更信息推送到回调地址。
                        <div class="url">{{moduleData.callbackUrl}}</div>

                    </div>
                    <span class="app-config__setting-btn" data-config="dataCallback" @click="setConfig(2)">设置</span>
                </div>
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>扫码登录配置</h4>
                    </div>
                    <div class="app-config__desc">
                        扫描二维码登录本应用的PC端。
                    </div>
                    <router-link class="app-config__setting-btn" :to="{
                        path: '/main/developmentSystem/permissionSystem/moduleApp/moduleAppScanConfigHelper',
                        query: {id}
                    }">查看详情</router-link>
                </div>
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>移动端入口集成</h4>
                        <span data-status="1" class="app-config__status">{{['', '已开启', '未开启'][moduleData.mobileUrlOnOff]}}</span>
                    </div>
                    <div class="app-config__desc">
                        在微校+主界面中点击应用图标直接进入应用内部。
                        <div class="url">{{moduleData.mobileUrl}}</div>

                    </div>
                    <span class="app-config__setting-btn" data-config="mobileEntry" @click="setConfig(3)">设置</span>
                </div>
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>Api权限设置</h4>
                    </div>
                    <div class="app-config__desc">
                        设置对外提供的api接口权限:
                        <div>{{apiPermission}}</div>
                    </div>
                    <span class="app-config__setting-btn" data-config="mobileEntry" @click="jumpToPage('moduleAppIntApi', {id})">设置</span>
                </div>
            </div>
            <el-dialog :title="dialogTitle" :visible.sync="isShowDialog" :close-on-press-escape='false'
                       width="600px"
                       :lock-scroll="false"
                       :close-on-click-modal='false' :modal-append-to-body='false'>
                <div>
                    <el-form ref="form" :model="formData" :rules="formRules" label-width="120px">
                        <el-form-item label="是否开启" prop="onOff">
                            <el-switch :active-value="1" :inactive-value="2" v-model="formData.onOff"></el-switch>
                        </el-form-item>
                        <el-form-item v-if="formData.onOff == 1" :label="dialogLabel" prop="url">
                            <el-input v-model.trim="formData.url" style="width: 400px;"></el-input>
                        </el-form-item>
                        <el-form-item v-if="type == 2 && formData.onOff == 1" label="接收下发内容">
                            <el-checkbox-group v-model="formData.dataRange">
                                <el-checkbox :label="item.id" :key="item.id" v-for="item in dataRangeList" >{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="setConfigConfirm">确定</el-button>
            </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        queryApiNameByModuleId
    } from '@/api/apiPermission';
    import BackTool from '@/components/BackTool';
    import {regexpUtil} from '@/utils/validate';
    import {queryModule, updateModuleConfig, updateModule} from '@/api/moduleApp';
    import mixin from "@/mixins/windowResize";
    export default {
        name: 'moduleAppIntDetail',
        components: {BackTool},
        data() {
            const validateUrl = (rule, value, callback) => {
                if(this.formData.onOff  == 1) {
                    this.formData.url = this.formData.url.trim();
                    if( this.formData.url === '') {
                        callback(new Error('请填写url'));
                    } else if(!regexpUtil.url.test(this.formData.url)) {
                        callback(new Error('url格式不正确'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }

            };
            return {
                id: this.$route.query.id,
                type: 1,
                isShowDialog: false,
                isShowPushDialog: false,
                moduleData: {},
                apiPermission: '',
                formData: {
                    url: '',
                    onOff: 2,
                    dataRange: []
                },
                formRules: {
                    url: [
                        { required: true, validator: validateUrl },
                    ],
                },
                dataRangeList: [{
                    id: '1001',
                    name: '用户'
                }, {
                    id: '1002',
                    name: '用户部门变更'
                }, {
                    id: '1003',
                    name: '用户账号变更'
                }, {
                    id: '1004',
                    name: '部门'
                }, {
                    id: '1005',
                    name: '人脸'
                }, {
                    id: '1006',
                    name: '部门主任'
                }, {
                    id: '1007',
                    name: '教师任教'
                }, {
                    id: '1008',
                    name: '一卡通'
                }, {
                    id: '1009',
                    name: '车辆管理'
                }]
            }
        },
        mixins: [mixin],
        computed: {
            dialogTitle() {
                let title = "";
                switch (`${this.type}`) {
                    case "1":
                        title = "PC端单点登录设置";
                        break;
                    case "2":
                        title = "数据下发配置";
                        break;
                    case "3":
                        title = "移动端单点登录设置";
                        break;
                }
                return title;
            },
            dialogLabel() {
                let label = "";
                switch (`${this.type}`) {
                    case "1":
                        label = "单点登录地址";
                        break;
                    case "2":
                        label = "数据回调地址";
                        break;
                    case "3":
                        label = "单点登录地址";
                        break;
                }
                return label;
            },
        },
        created() {
            this.queryModuleFunc();
            queryApiNameByModuleId({
                moduleId: this.id
            })
                .then(data => {
                    this.apiPermission = data.join(',');
                })
            // queryApiPermTree({
            //     module: true
            // })
            //     .then(data => {
            //         console.log(data)
            //     })
        },
        methods: {
            jumpToPage(path, query) {
                if (query === undefined || query === null) {
                    query = {}
                }
                this.$router.push({
                    path,
                    query
                })
            },
            queryModuleFunc() {
                queryModule({
                    id: this.id
                })
                    .then(data => {
                        data.mobileUrlOnOff = data.mobileUrlOnOff || 2;
                        data.callbackUrlOnOff = data.callbackUrlOnOff || 2;
                        data.pcUrlOnOff = data.pcUrlOnOff || 2;
                        this.moduleData = data;
                        this.formData.dataRange = data.dataRange.split(',')
                    })
            },
            setConfig(type) {
                this.type = type;
                this.isShowDialog = true;

                switch(type) {
                    case 1||'1':
                        this.formData.url = JSON.parse(JSON.stringify(this.moduleData.pcUrl));
                        this.formData.onOff = JSON.parse(JSON.stringify(this.moduleData.pcUrlOnOff));
                        break;
                    case 2||'2':
                        this.formData.url = JSON.parse(JSON.stringify(this.moduleData.callbackUrl));
                        this.formData.onOff = JSON.parse(JSON.stringify(this.moduleData.callbackUrlOnOff));

                        break;
                    case 3||'3':
                        this.formData.url = JSON.parse(JSON.stringify(this.moduleData.mobileUrl));
                        this.formData.onOff = JSON.parse(JSON.stringify(this.moduleData.mobileUrlOnOff));

                        break;
                }
            },
            setConfigConfirm() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        const args = {
                            type: this.type,
                            id: this.id
                        };
                        switch(args.type) {
                            case 1||'1':
                                args.pcUrl = this.formData.url;
                                args.pcUrlOnOff = this.formData.onOff;
                                break;
                            case 2||'2':
                                args.callbackUrl = this.formData.url;
                                args.callbackUrlOnOff = this.formData.onOff;
                                args.dataRange = this.formData.dataRange.join(',');
                                break;
                            case 3||'3':
                                args.mobileUrl = this.formData.url;
                                args.mobileUrlOnOff = this.formData.onOff;
                                break;
                        }
                        new Promise(resolve => {
                            if(args.type == 2) {
                                updateModule(args)
                                    .then(resolve)
                            } else {
                                updateModuleConfig(args)
                                    .then(resolve)
                            }
                        })
                            .then(() => {
                                this.$message.success('设置成功');
                                this.isShowDialog = false;
                                this.queryModuleFunc();
                            })
                    }
                })

            }
        }
    }
</script>

<style lang="scss" scoped>
    h4, p {
        margin: 0;
    }
    .moduleAppIntDetail{
        padding:12px;
    }
    .top{
        border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
    }
    .clear-div {
        clear: both;
    }
    .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
        clear: both;
    }
    .wxcep-table pre {
        color: #C7254E;
    }
    /*============== applicationDetail.html ===========*/
    .application-info {
        margin-bottom: 10px;
    }
    .application-info .logo {
        width: 80px;
        height: 80px;
        vertical-align: middle;
        display: inline-block;
        margin-right: 10px;
    }
    .application-info .application-name {
        display: inline-block;
        vertical-align: middle;
    }
    .application-name__main  {
        margin-bottom: 10px;
    }
    .application-name__desc {
        color: #888;
    }
    .detail-info {
        margin-top: 20px;
    }
    .detail-info__item {
        float: left;
        width: 36%;
        white-space: nowrap;

        margin-bottom: 20px;
        p {
            white-space: nowrap;
            max-width: 80%;
            vertical-align: middle;
            overflow-x: hidden;
            text-overflow: ellipsis;
        }
    }
    .app-config {
        border-radius: 5px;
        box-shadow: #999 0 0 10px;
        width: 30%;
        margin: 0 3% 33px 0;
        float: left;
        border: 1px solid #999;
        position: relative;
    }
    .app-config .app-config__title {
        border-bottom: 1px solid #999;
        padding: 10px;
        position: relative;
    }
    .app-config__title h4 {
        font-size: 20px;
        float: left;
        font-weight: bold;
    }
    .app-config__status {
        float: right;
        line-height: 22px;
    }
    .app-config__desc {
        padding: 20px 10px;
        min-height: 140px;
    }
    .app-config__setting-btn {
        position: absolute;
        right: 10px;
        bottom: 5px;
        color: #409EFF;
        cursor: pointer;
    }
    /*=============== scanLoginIntro.html ========*/
    .intro-title {
        margin: 5px 0;
        font-size: 16px;
        font-weight: bold;
    }
    .detail-info__item {
        & > span {
            display: inline-block;
            text-align: right;
            width: 100px;
        }

    }
    .detail-info__item p{
        display: inline-block;
    }
    .url {
        word-break: break-all;
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/moduleApp/moduleAppIntDetail.vue